function wbInitCartUpsellSwiper(root = document) {
  const scope = root && typeof root.querySelector === 'function' ? root : document;
  const el = scope.matches && scope.matches('#swiper-upsells') ? scope : scope.querySelector('#swiper-upsells');
  if (!el || typeof Swiper === 'undefined') return false;

  const next = el.querySelector('.upsell-next-btn');
  const prev = el.querySelector('.upsell-prev-btn');
  const current = el.swiper;
  const navigationRequired = Boolean(next && prev);
  const navigationMatches =
    !navigationRequired ||
    (current &&
      current.navigation &&
      current.navigation.nextEl === next &&
      current.navigation.prevEl === prev);

  if (current && !current.destroyed && navigationMatches) {
    current.update();
    return true;
  }

  if (current && typeof current.destroy === 'function' && !current.destroyed) {
    try {
      current.destroy(true, true);
    } catch (error) {
      console.warn('Upsell-Swiper konnte nicht sauber neu initialisiert werden:', error);
    }
  }

  const config = {
    slidesPerView: 1.4,
    spaceBetween: 10,
    observer: true,
    observeParents: true,
    noSwipingSelector: 'input, select, option, textarea, label, video',
    breakpoints: {
      460: {
        slidesPerView: 2.3,
      },
    },
  };

  if (navigationRequired) {
    config.navigation = {
      nextEl: next,
      prevEl: prev,
    };
  }

  new Swiper(el, config);
  return true;
}

window.wbInitCartUpsellSwiper = wbInitCartUpsellSwiper;

/* Topseller-Slider des leeren Warenkorb-Flyouts nachladen (2026-09-29).
   Der Flyout liefert nur noch einen Platzhalter [data-wb-topseller]; der Inhalt kommt aus
   sections/wb-cart-topseller.liquid über die Section Rendering API. Das HTML wird einmal
   geholt und bei jedem Neuaufbau des Flyouts (Ajax nach Warenkorb-Änderung) wieder
   eingesetzt. Mit nurVorladen = true wird nur geholt, nicht eingesetzt. */
var wbTopsellerHtml = null;
var wbTopsellerAnfrage = null;

function wbTopsellerHolen() {
  if (wbTopsellerHtml !== null) return Promise.resolve(wbTopsellerHtml);
  if (wbTopsellerAnfrage) return wbTopsellerAnfrage;
  var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  wbTopsellerAnfrage = fetch(wurzel + '?sections=wb-cart-topseller')
    .then(function (antwort) { return antwort.ok ? antwort.json() : {}; })
    .then(function (daten) {
      var html = (daten && daten['wb-cart-topseller']) || '';
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var huelle = doc.querySelector('.shopify-section');
      wbTopsellerHtml = huelle ? huelle.innerHTML : '';
      return wbTopsellerHtml;
    })
    .catch(function () { wbTopsellerAnfrage = null; return ''; });
  return wbTopsellerAnfrage;
}

function wbTopsellerStarten(platz) {
  var el = platz.querySelector('#swiper-topseller');
  if (!el || el.swiper || typeof Swiper === 'undefined') return;
  new Swiper(el, {
    slidesPerView: 2,
    spaceBetween: 16,
    observer: true,
    scrollbar: {
      el: el.querySelector('.swiper-scrollbar'),
      draggable: true,
    },
    navigation: {
      nextEl: el.querySelector('.next-btn'),
      prevEl: el.querySelector('.prev-btn'),
    },
  });
}

function wbTopsellerLaden(drawer, nurVorladen) {
  var platz = (drawer || document).querySelector('[data-wb-topseller]');
  if (!platz) return;
  if (platz.hasAttribute('data-wb-geladen')) { wbTopsellerStarten(platz); return; }
  wbTopsellerHolen().then(function (html) {
    if (nurVorladen || !html || !platz.isConnected || platz.hasAttribute('data-wb-geladen')) return;
    platz.innerHTML = html;
    /* Per innerHTML eingesetzte script-Tags laufen nicht — die Karten brauchen ihre
       Hover-Funktionen (wbFarbbildZeigen …) aber, falls die Seite selbst keine Karten hat. */
    platz.querySelectorAll('script').forEach(function (alt) {
      var neu = document.createElement('script');
      neu.textContent = alt.textContent;
      alt.replaceWith(neu);
    });
    platz.setAttribute('data-wb-geladen', '');
    wbTopsellerStarten(platz);
  });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // Shopify ersetzt den Cart-Drawer nach Ajax-Updates per HTML. Dabei werden
    // Script-Tags aus dem neu eingesetzten Section-HTML nicht erneut ausgefuehrt.
    // Deshalb lebt die Upsell-Swiper-Initialisierung hier im dauerhaft geladenen
    // Asset und reagiert auf jeden Austausch innerhalb des Drawers.
    this.upsellSwiperTimer = null;
    this.upsellObserver = new MutationObserver(() => {
      if (this.upsellSwiperTimer) window.clearTimeout(this.upsellSwiperTimer);
      this.upsellSwiperTimer = window.setTimeout(() => {
        wbInitCartUpsellSwiper(this);
        if (this.classList.contains('active')) wbTopsellerLaden(this);
      }, 50);
    });
    this.upsellObserver.observe(this, { childList: true, subtree: true });

    if (document.readyState === 'complete') {
      wbInitCartUpsellSwiper(this);
    } else {
      window.addEventListener('load', () => wbInitCartUpsellSwiper(this), { once: true });
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble-outer');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    /* Topseller vorladen, sobald sich der Zeiger/Finger dem Warenkorb-Symbol nähert —
       bis zum Klick ist der Slider meist schon da (2026-09-29). */
    ['pointerenter', 'touchstart', 'focus'].forEach((typ) =>
      cartLink.addEventListener(typ, () => wbTopsellerLaden(this, true), { once: true, passive: true })
    );
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    wbTopsellerLaden(this);
    wbInitCartUpsellSwiper(this);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        const targetElement = this; // Replace with the actual element

        const observer = new MutationObserver(() => {
          if (targetElement.classList.contains('is-empty')) {
            wbTopsellerLaden(targetElement);
          }
        });

        observer.observe(targetElement, { attributes: true, attributeFilter: ['class'] });

        if (this.classList.contains('is-empty')) {
          wbTopsellerLaden(this);
        }
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Direkt nach dem Section-Austausch initialisieren. Der Observer oben ist
    // zusaetzlich das Sicherheitsnetz fuer andere Cart-Ajax-Pfade.
    wbInitCartUpsellSwiper(this);

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Event listener for external cart addition from wbconnect.de
window.addEventListener('message', function (event) {
  if (event.origin === 'https://ui.pcon-solutions.com') {
    if (typeof event.data.data !== 'undefined' && event.data.data.type === 'sendOCI') {
      const pconLoader = document.querySelector('#pcon-loader');
      if (pconLoader) {
        pconLoader.classList.remove('!od-hidden');
      }
    }
  }

  if (event.origin !== 'https://wbconnect.de') return; // Sicherheit!
  // Show pcon-loader if it exists

  const { variantId } = event.data;
  const { quantity } = event.data;
  const { obxUrl } = event.data;
  const { skus } = event.data;
  const { imageUrl } = event.data;
  const { configText } = event.data;
  console.log('Received message from wbconnect.de:', event.data);

  // Konfigurationsdaten als Line-Item-Properties an die Bestellposition haengen. Nur dort
  // ueberleben sie das Loeschen der Shopify-Wegwerf-Variante: Varianten-Metafelder sterben mit
  // ihr, Properties sind nach dem Add-to-Cart unveraenderlich und Teil der Bestellung.
  // Das '_'-Praefix blendet sie in Warenkorb-/Checkout-Anzeige aus (bestehende Konvention),
  // per Liquid bleiben sie lesbar. Nur setzen, wenn vorhanden - eine aeltere Middleware
  // schickt kein imageUrl mit.
  const properties = {};
  if (imageUrl) properties._pcon_image = imageUrl;
  if (obxUrl) properties._obx_url = obxUrl;
  if (configText) properties._pcon_config = configText;

  const cartPayload = { id: variantId, quantity: quantity };
  if (Object.keys(properties).length > 0) cartPayload.properties = properties;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cartPayload),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('Item added to cart:', data);

      // Use the same approach as cart.js onCartUpdate for cart-drawer-items
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        // Fetch cart drawer content and update like in cart.js
        // Cache-bust + no-store: Shopify section endpoint kann direkt nach cart/add.js
        // einen veralteten Render zurückgeben (kein Title/Image). Forciere frische Response.
        fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, {
          cache: 'no-store',
          headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
        })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.drawer__footer'];

            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }

            // Update cart drawer state
            cartDrawer.classList.toggle('is-empty', data.item_count === 0);

            // Publish cart update event
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'external-wbconnect',
                productVariantId: variantId,
                cartData: data,
              });
            }

            // Upsell-Slider nach dem Ajax-Austausch mit denselben Einstellungen
            // wie im normalen Warenkorbpfad initialisieren.
            wbInitCartUpsellSwiper(cartDrawer);

            // Close product popup modal if it's open before opening cart drawer
            const productPopupModal = document.querySelector('.product-popup-modal');
            if (productPopupModal && productPopupModal.hasAttribute('open')) {
              // Remove open attribute
              productPopupModal.removeAttribute('open');
              // Remove body scroll lock if present
              document.body.classList.remove('overflow-hidden');
              const pconLoader = document.querySelector('#pcon-loader');

              if (pconLoader) {
                pconLoader.classList.add('!od-hidden');
              }

              // Wait a bit for the modal close animation
              setTimeout(() => {
                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                  const pconIframe = document.querySelector('#pcon-configurator');
                  if (pconIframe) {
                    const currentSrc = pconIframe.src;
                    pconIframe.src = '';
                    pconIframe.src = currentSrc;
                  }
                }
              }, 200);
            } else {
              // Open the cart drawer immediately if no modal is open
              setTimeout(() => {
                if (typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                }
              }, 100);
            }
          })
          .catch((error) => {
            console.error('Error fetching cart drawer content:', error);
          });
      }
    })
    .catch((error) => {
      console.error('Error adding item to cart:', error);
    });
});
